import { ActionsPopoverMenu, type ActionItem } from '../ActionsPopoverMenu/ActionsPopoverMenu'
import { InfoIcon, PencilIcon, TrashIcon } from '../icons'

export type RowActionsMenuLabels = {
  edit: string
  delete: string
  view?: string
}

export type RowActionsMenuProps = {
  onEdit: () => void
  onDelete: () => void
  onView?: () => void
  labels: RowActionsMenuLabels
  isDisabled?: boolean
}

const iconClassName = 'size-6'

export function RowActionsMenu({
  onEdit,
  onDelete,
  onView,
  labels,
  isDisabled = false
}: RowActionsMenuProps) {
  const actions: ActionItem[] = []

  if (onView && labels.view) {
    actions.push({
      label: labels.view,
      icon: <InfoIcon className={iconClassName} />,
      onClick: onView
    })
  }

  actions.push(
    {
      label: labels.edit,
      icon: <PencilIcon className={iconClassName} />,
      onClick: onEdit,
      disabled: isDisabled
    },
    {
      label: labels.delete,
      icon: <TrashIcon className={iconClassName} />,
      onClick: onDelete,
      disabled: isDisabled,
      className: 'text-red-500'
    }
  )

  return <ActionsPopoverMenu actions={actions} />
}
